import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Section from '../../Components/Section'
import Loader from '../../Components/Loader'
import Poster from '../../Components/Poster'
import { Helmet } from 'react-helmet'
import Error from '../../Components/Error'
import TvComponent from '../../Components/TvComponent'

const Container = styled.div`
    padding:50px 60px 70px;
    @media screen and (max-width:768px) {
        padding:5px;
    }
`

const TVPresenter = ({ topRated, popular, airingToday, error, loading }) => loading ? <Loader /> : error ? <Error data={'No Data'} /> : (
    <Container>
        <Helmet>
            <title>
                TV Shows | Maflix
            </title>
        </Helmet>
        <TvComponent />
        {topRated && topRated.length > 0 && (
            <Section section={'/show/sub/top/'} title={'Top Rated Shows'}>{topRated.map(i => <Poster key={i.id} id={i.id} imgUrl={i.poster_path} title={i.name} rating={i.vote_average} year={i.first_air_date && i.first_air_date.substring(0, 4)} isMovie={false} />)}</Section>
        )}
        {popular && popular.length > 0 && (
            <Section section={'/show/sub/popshow/'} title={'Popular TV Shows'}>{popular.map(i => <Poster key={i.id} id={i.id} imgUrl={i.poster_path} title={i.name} rating={i.vote_average} year={i.first_air_date && i.first_air_date.substring(0, 4)} isMovie={false} />)}</Section>
        )}
        {airingToday && airingToday.length > 0 && (
            <Section section={'/show/sub/air/'} title={'Airing Today'}>{airingToday.map(i => <Poster key={i.id} id={i.id} imgUrl={i.poster_path} title={i.name} rating={i.vote_average} year={i.first_air_date && i.first_air_date.substring(0, 4)} isMovie={false} />)}</Section>
        )}
        {error && <Error color='#e74c3c' data={'No Data'} />}
    </Container>
)




TVPresenter.propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    topRated: PropTypes.array,
    popular: PropTypes.array,
    airingToday: PropTypes.array
}

export default TVPresenter